export const GroupEntriesQueryKeys = {
  entryViewsRoot: () => ['group-entry-views'] as const,
  // Sorted so reordered IDs hit the same cache entry.
  entryViews: (userId: string, entryIds: readonly string[]) =>
    ['group-entry-views', userId, [...entryIds].sort()] as const,
  // Prefix of every entryViews key for this user; used for post-mutation invalidation.
  entryViewsForUser: (userId: string) => ['group-entry-views', userId] as const,
  currentUserChannel: (userId: string) => ['group-current-user-channel', userId] as const,
  channelSearch: (userId: string, query: string) =>
    ['group-channel-search', userId, query] as const,
  // User-scoped so one viewer's invite cache never serves another's.
  invite: (userId: string, inviteId: string) => ['group-invite', userId, inviteId],
  receivedInvites: (userId: string, status?: string) => [
    'group-received-invites',
    userId,
    ...(status ? [status] : []),
  ],
};
